module.exports = __webpack_public_path__ + "assets/img/6.893f55db.png";